<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         :viewBox="viewBox" style="enable-background:new 0 0 107.6 126.5;" xml:space="preserve">
        <component :is="component" v-if="component" :color="settings.clothColor" />
    </svg>
</template>

<script>
    export default {
        name: 'ClothLoader',
        props: {
            isPreview: {
                type: Boolean,
                required: false,
                default () {
                    return false;
                },
            },
            settings: {
                type: Object,
                required: true,
            },
            cloth: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                component: null,
            }
        },
        computed: {
            viewBox () {
                return this.isPreview ? '35 25 40 35' : '0 0 107.6 126.5';
            },
            loader () {
                return () => {
                    return import(`./${this.cloth}`);
                }
            },
        },
        mounted () {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                });
        },
    }
</script>
